const testimoniosData = [
  {
    id: 1,

    name: 'Tek Boharadur',

    testimonial: {
      es: 'José Manuel es realmente bueno llevando la complejidad a terrenos en los que cualquier persona pueda abordarla, con independencia de su bagaje personal o profesional.',

      en: 'José Manuel is exceptionally good at making complexity accessible, allowing anyone to approach it regardless of their personal or professional background.',
    },

    position: {
      es: 'Gerente académico',
      en: 'Academic Manager',
    },
  },

  {
    id: 2,

    name: 'Stefano F.',

    testimonial: {
      es: 'José Manuel logra generar un entorno en el que visiones que originalmente parecían divergentes acaban combinándose de una manera natural para generar soluciones.',

      en: 'José Manuel creates an environment where perspectives that initially appeared divergent naturally come together to generate solutions.',
    },

    position: {
      es: 'Técnico de investigación',
      en: 'Research Technician',
    },
  },

  {
    id: 3,

    name: 'Davinia S.J.',

    testimonial: {
      es: 'José Manuel conecta y empatiza de una manera tan profunda, pero también tan auténtica, que resulta difícil no comprometerse con una misma y con su mejora personal después de trabajar con él.',

      en: 'José Manuel connects and empathises in such a deep yet authentic way that it is difficult not to commit to yourself and your personal growth after working with him.',
    },

    position: {
      es: 'Coachee',
      en: 'Coachee',
    },
  },

  {
    id: 4,

    name: 'Eduardo S.',

    testimonial: {
      es: 'José Manuel es claro y directo con sus procesos colectivos, pero, sobre todo, es muy eficaz: explica las normas del juego y, automáticamente, los alumnos entran en dinámicas creativas. No es nada dirigista y sabe hacer fluir el trabajo de los equipos. Llevo años contando con él para mis hackathones y seguiré haciéndolo: siempre es diferente, siempre es divertido y siempre es productivo.',

      en: 'José Manuel is clear and direct when leading collective processes, but above all, he is highly effective. He explains the rules of the game and the students immediately engage in creative dynamics. He is not directive and knows how to make teamwork flow. I have relied on him for my hackathons for years and will continue to do so: it is always different, always enjoyable and always productive.',
    },

    position: {
      es: 'Director de Departamento de Emprendimiento en Universidad',

      en: 'Head of a University Entrepreneurship Department',
    },
  },

  {
    id: 5,

    name: 'Annabelle L.',

    testimonial: {
      es: 'He visto a José Manuel facilitar procesos con agentes cuyos intereses eran radicalmente opuestos y en los que la esperanza de éxito era mínima o nula. En cuatro horas, no solo se había construido una serie de acuerdos, sino que las relaciones del ecosistema se habían transformado mediante el diálogo.',

      en: 'I have seen José Manuel facilitate processes involving stakeholders whose interests were radically opposed and where there was little or no hope of success. Within four hours, not only had a series of agreements been reached, but the relationships within the ecosystem had also been transformed through dialogue.',
    },

    position: {
      es: 'Responsable de Políticas Públicas',
      en: 'Public Policy Manager',
    },
  },

  {
    id: 6,

    name: 'Louise J.',

    testimonial: {
      es: 'José Manuel aporta energía, pero también capacidad para templar ambientes tensos. Me gusta cómo utiliza las herramientas de Design Thinking porque podría conducir las sesiones perfectamente sin ellas. Para él, lo importante es respetar el objetivo del cliente, no lucirse. Tiene una ética de trabajo impecable. 100 % recomendable.',

      en: 'José Manuel brings energy as well as the ability to ease tense environments. I like the way he uses Design Thinking tools because he could lead the sessions perfectly well without them. For him, respecting the client’s objective is more important than showcasing himself. His work ethic is impeccable. 100% recommended.',
    },

    position: {
      es: 'Responsable de Innovación en Corporación Pública',

      en: 'Innovation Manager at a Public Corporation',
    },
  },

  {
    id: 7,

    name: 'Roberta G.',

    testimonial: {
      es: 'Genera la combinación perfecta entre alta productividad y buen ambiente. Es imposible no sentirse comprometido durante sus sesiones.',

      en: 'He creates the perfect combination of high productivity and a positive atmosphere. It is impossible not to feel engaged during his sessions.',
    },

    position: {
      es: 'Responsable Técnica en el Ámbito de las Energías Renovables',

      en: 'Technical Manager in the Renewable Energy Sector',
    },
  },

  {
    id: 8,

    name: 'Natalia C.A.',

    testimonial: {
      es: 'Didáctico, inspirador y sanador. Tuve el placer y la suerte de tener a José Manuel como coach en un hackathon de emprendimiento. Fue una experiencia que me hizo crecer a todos los niveles y marcó un antes y un después en mi vida.',

      en: 'Educational, inspiring and healing. I had the pleasure and good fortune of having José Manuel as my coach during an entrepreneurship hackathon. It was an experience that helped me grow at every level and marked a turning point in my life.',
    },

    position: {
      es: 'Estudiante universitaria',
      en: 'University Student',
    },
  },
];

export default testimoniosData;